import React from 'react';
import { TimeEstimate } from '@atlassian/jira-issue-time-estimate/src/ui/edit/index.tsx';
import { withFormField } from '../../common/ui/with-form-field/index.tsx';
import type {
	Props,
	TimeTrackingFieldConfig,
	FieldValue,
	TimeTrackingDefaultValue,
} from './types.tsx';
import { validateTimeTrackingField } from './utils.tsx';

const TimeTrackingField = (props: Props) => {
	const {
		fieldProps: { value = '', onChange, ...fieldProps },
		setValueExternal,
		additionalData: { timeTrackingSettings: config },
		fieldId,
	} = props;

	const onTimeEstimateChange = (timeEstimateValue: string) => {
		onChange(timeEstimateValue);
		setValueExternal(timeEstimateValue);
	};

	return (
		<TimeEstimate
			{...fieldProps}
			fieldId={fieldId}
			value={value}
			onChange={onTimeEstimateChange}
			config={config}
		/>
	);
};

export { TimeTrackingField };
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export type { TimeTrackingDefaultValue };

export default withFormField({
	validator: validateTimeTrackingField,
	// @ts-expect-error - TS2345 - Argument of type '(props: Props) => JSX.Element' is not assignable to parameter of type 'AbstractComponent<ComponentProps<TimeTrackingFieldConfig, string>, any>'.
})<TimeTrackingFieldConfig, FieldValue>(TimeTrackingField);
